// extracted by mini-css-extract-plugin
module.exports = {"loader-indicator":"drawer-loader_loader-indicator__ro1BJ"};